<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f" id="contents"><a id="page_7"></a><strong>CONTENTS</strong></h2>
<p class="toc1"><a href="#/xhtml/preface#preface">PREFACE</a></p>
<p class="toc1"><a href="#/xhtml/fm02#fm02">A FEW WORDS ON THE INGREDIENTS</a></p>
<p class="toc1"><a href="#/xhtml/fm03#fm03">CHRISTMAS STRESS-RELIEF TIPS</a></p>
<p class="toc1"><a href="#/xhtml/ch01#ch01">THE MORNING</a></p>
<p class="toc1"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample">DRINKS</span></p>
<p class="toc1"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample">SNACKS</span></p>
<p class="toc1"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample">SOUPS</span></p>
<p class="toc1"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample">SMALL PLATES</span></p>
<p class="toc1"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample">MAIN COURSES</span></p>
<p class="toc1"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample">SIDE DISHES</span></p>
<p class="toc1"><span href="#/xhtml/ch08#ch08" title="Link target outside of Sample">DESSERTS</span></p>
<p class="toc1"><span href="#/xhtml/ch09#ch09" title="Link target outside of Sample">PANTRY</span></p>
<p class="toc1"><span href="#/xhtml/ch10#ch10" title="Link target outside of Sample">MENUS</span></p>
<p class="toc1"><span href="#/xhtml/index#index" title="Link target outside of Sample">INDEX OF SEARCHABLE TERMS</span></p>
<p class="toc1"><span href="#/xhtml/thank#thank" title="Link target outside of Sample">THANK YOU</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2eb39be8